import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  setSelectedObjects, 
  toggleSelectedObject, 
  clearSelectedObjects 
} from '../redux/migrationSlice';
import {STATUS} from '../constants/migrationConstants'

const useObjectSelection = (objects) => {
  const dispatch = useDispatch();
  const selectedObjects = useSelector((state) => state.migration.selectedObjects);

  const handleSelectAll = useCallback(() => {
    const availableObjects = objects
      .filter(obj => obj.status !== STATUS.STATUS_COMPLETED)
      .map(obj => obj.id);
    dispatch(setSelectedObjects(availableObjects));
  }, [objects, dispatch]);

  const handleClearAll = useCallback(() => {
    dispatch(clearSelectedObjects());
  }, [dispatch]);

  const handleToggleObject = useCallback((objectId) => {
    const object = objects.find(obj => obj.id === objectId);
    if (object?.status !== STATUS.STATUS_COMPLETED) {
      dispatch(toggleSelectedObject(objectId));
    }
  }, [objects, dispatch]);

  return {
    selectedObjects,
    selectedCount: selectedObjects.length,
    handleSelectAll,
    handleClearAll,
    handleToggleObject,
    isSelected: (objectId) => selectedObjects.includes(objectId)
  };
};

export default useObjectSelection;